export const IMAGE_VERSION = 'v2';